import { assetFolders } from 'common/constants'
import { SpinnerIcon } from 'images/icon/SpinnerIcon'
import { PropsWithChildren } from 'react'
import { Spinner } from 'react-bootstrap'
import { useGlobalStore } from 'store/useGlobalStore'
import { IProps, ISpinnerProps, StyleCustomLoader, StyledLoader, StyledPageLoader } from './Loader.styled'

export const Loader = ({ children, overlay, variant = 'primary' }: PropsWithChildren<IProps>) => {
  const [assetFolder] = useGlobalStore((state) => [state.userClaims.CurrentBuyerTypeAssetFolder])
  return (
    <StyledLoader overlay={overlay}>
      <Spinner animation="border" variant={assetFolder === assetFolders.Infiniti ? '#E3E4E5' : variant}>
        {children}
      </Spinner>
    </StyledLoader>
  )
}

export const OverlayLoader = () => {
  return (
    <StyledPageLoader>
      <Loader overlay />
    </StyledPageLoader>
  )
}

export const CustomLoader = ({ size, color }: ISpinnerProps) => {
  return (
    <StyleCustomLoader>
      <SpinnerIcon className="custom-spinner" width={size} height={size} color={color} />
    </StyleCustomLoader>
  )
}
